import React, { useState, useEffect, useRef } from "react";
import { useLocation } from "react-router-dom";

import Ysafe from "./Ysafe/index";
import YsentinelOne from "./YsentinalOne/YsentinalOne";
import Tabs from "components/Tabs/index";
import TimeRangePicker from "./YsentinalOne/TimeRangePicker";
import { YsentinelDataProvider } from "./YsentinalOne/data/YsentinelDataContext";
import {
  SummaryDashboard,
  FilesDashboard,
  UsersDashboard,
  LocationsDashboard,
} from "./YsentinalOne/Dashboards";
import Spaces from "./Spaces/Spaces";
import Logs from "components/Logs/Logs";
import Input from "components/Input/index";
import Button from "components/Button/index";
import Dropdown from "components/DropDowns/customDropDown/index";
import TextDropDown from "components/DropDowns/TextDropDowns/index";
import SortIcons from "../../constants/Homepage/ysafe/iconFunctions/sortIcons";
import { TabIcons } from "../../constants/Homepage/ysafe/iconFunctions/tabIcons";
import { Item, ManageUser, Organization, getPermissionNumber } from "@induz/sdk";
import { useToast } from "components/Toaster/index";

import logo from "../../assets/images/homepage/main/logo.svg";
import logoDark from "../../assets/images/homepage/main/logoDark.svg";
import button from "../../assets/images/homepage/Button.svg";
import buttonDark from "../../assets/images/homepage/Button Dark.svg";

import ysafe from "../../assets/images/homepage/main/ysafe.svg";
import ysafeDark from "../../assets/images/homepage/main/ysafeDark.svg";
import passwordManager from "../../assets/images/homepage/main/passwordManager.svg";
import passwordManagerDark from "../../assets/images/homepage/main/passwordManagerDark.svg";
import reportAnalysis from "../../assets/images/homepage/main/reportAnalyticsLight.svg";
import reportAnalysisDark from "../../assets/images/homepage/main/reportAnalytics.svg";
import { TaskManager } from "@induz/sdk";

// Spaces icon - inline SVG component with theme support
const SpacesIcon = ({ isActive, theme }) => {
  const strokeColor = isActive
    ? (theme === "light" ? "#67308F" : "#A78BFA")
    : (theme === "light" ? "#6B7280" : "#9CA3AF");

  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={{
        display: "block",
        width: "24px",
        height: "24px",
        flexShrink: 0
      }}
    >
      <rect
        x="3"
        y="4"
        width="14"
        height="14"
        rx="2"
        ry="2"
        stroke={strokeColor}
        strokeWidth="1.6"
        fill="none"
      />
      <path
        d="M11 9H21M21 9V3M21 9L17 5"
        stroke={strokeColor}
        strokeWidth="1.6"
        strokeLinecap="round"
        fill="none"
      />
    </svg>
  );
};

import downArrow from "../../assets/images/homepage/downArrow.svg";
import logoIcon from "../../assets/images/homepage/logoIcon.svg";
import logoIconDark from "../../assets/images/homepage/logoIcondark.svg";

import "./homepage.scss";
// import Download from "./Download/index";
import RenewalCard from "./RenewalCard/index";
import PlanExpiredMarquee from "./PlanExpiredMarquee/index";

import useScreenMobile from "hooks/useScreen";
import useTheme from "hooks/observer";
import Tooltip from "components/Tooltip/index";
import Profile from "./Profile/index";
import Notification from "components/Notifications/index";
import SettingsContainer from "containers/SettingsContainer/index";
import SecretManagement from "containers/SecretManagement/index";
import AlertsPage from "containers/Alerts/index";
import NewFileModal from "components/NewFileModal.jsx";
import Drawer from "components/Drawer/index";
import AdvancedSearchModal from "./Ysafe/GlobalSearch/AdvancedSearchModal";

function Homepage() {
  const USER_OPS_SESSION_KEY = "userOperations";
  const normalizeOperationIds = (ops) =>
    (Array.isArray(ops) ? ops : [])
      .map((op) => {
        if (typeof op === "number" || typeof op === "string") return Number(op);
        if (typeof op === "bigint") return Number(op);
        if (op && typeof op === "object" && "role" in op) return Number(op.role);
        return NaN;
      })
      .filter((n) => Number.isFinite(n));
  const [filesActiveTab, setFilesActiveTab] = useState(0);
  const [advancedSearchOpen, setAdvancedSearchOpen] = useState(false);
  useEffect(() => {
    const handler = (e) => {
      if (typeof e?.detail === "number") setFilesActiveTab(e.detail);
    };
    window.addEventListener("filesTabChanged", handler);
    return () => window.removeEventListener("filesTabChanged", handler);
  }, []);

  const [activeCard, setActiveCard] = useState(() => {
    const savedActiveCard = sessionStorage.getItem("activeCard");
    return savedActiveCard ? parseInt(savedActiveCard, 10) : 0;
  });

  const theme = useTheme();

  const [compress, setCompress] = useState(false);
  const [dropdown, setDropdown] = useState(false);
  const [download, setDownload] = useState(true);
  const [showRenewalCard, setShowRenewalCard] = useState(true);
  const [profile, setProfile] = useState(false);
  const [setting, setSetting] = useState(false);
  const [headerProfilePicUrl, setHeaderProfilePicUrl] = useState(null);
  const [spacesHover, setSpacesHover] = useState(false);

  // YsentinalOne history state
  const [ysentinalHistory, setYsentinalHistory] = useState([]);
  const [isHistoryOpen, setIsHistoryOpen] = useState(false);

  // Track if Ysentinel has table data
  const [hasYsentinelData, setHasYsentinelData] = useState(false);

  // Backend-derived: plan and user type for Ysentinel (no sessionStorage)
  const [backendPlanId, setBackendPlanId] = useState(null);
  const [backendPlanExpiry, setBackendPlanExpiry] = useState(null);
  const [backendIsIndividual, setBackendIsIndividual] = useState(null);
  const [backendIsOrgAdmin, setBackendIsOrgAdmin] = useState(null);
  const [backendOperations, setBackendOperations] = useState([]);

  const location = useLocation();
  const didRefetchAfterUpgrade = useRef(false);

  const detectImageMimeType = (bytes) => {
    if (!bytes || bytes.length < 4) return "image/png";
    const s = Array.from(bytes.slice(0, 12));
    if (s[0] === 0x89 && s[1] === 0x50 && s[2] === 0x4e && s[3] === 0x47) return "image/png";
    if (s[0] === 0xff && s[1] === 0xd8 && s[2] === 0xff) return "image/jpeg";
    if (s[0] === 0x47 && s[1] === 0x49 && s[2] === 0x46) return "image/gif";
    if (s[0] === 0x42 && s[1] === 0x4d) return "image/bmp";
    if (s[0] === 0x52 && s[1] === 0x49 && s[2] === 0x46 && s[3] === 0x46 && s[8] === 0x57 && s[9] === 0x45 && s[10] === 0x42 && s[11] === 0x50) return "image/webp";
    return "image/png";
  };

  const refreshHeaderProfilePic = () => {
    const mail = sessionStorage.getItem("mail");
    if (!mail) return;
    ManageUser.getUserDetails(mail, false)
      .then((details) => {
        let picBytes = null;
        if (details instanceof Organization) {
          picBytes = details.getLogo?.();
        } else {
          picBytes = details.getProfilePicture?.();
        }
        if (picBytes && picBytes.length > 0) {
          const base64 = btoa(String.fromCharCode(...picBytes));
          const mime = detectImageMimeType(picBytes);
          setHeaderProfilePicUrl(`data:${mime};base64,${base64}`);
        } else {
          setHeaderProfilePicUrl(null);
        }
      })
      .catch(() => setHeaderProfilePicUrl(null));
  };

  // Load profile pic/logo for header circle (individual = profile picture, org = logo)
  useEffect(() => {
    const mail = sessionStorage.getItem("mail");
    if (!mail) return;
    let cancelled = false;
    ManageUser.getUserDetails(mail, false)
      .then((details) => {
        if (cancelled) return;
        let picBytes = null;
        if (details instanceof Organization) {
          picBytes = details.getLogo?.();
        } else {
          picBytes = details.getProfilePicture?.();
        }
        if (picBytes && picBytes.length > 0) {
          const base64 = btoa(String.fromCharCode(...picBytes));
          const mime = detectImageMimeType(picBytes);
          setHeaderProfilePicUrl(`data:${mime};base64,${base64}`);
        } else {
          setHeaderProfilePicUrl(null);
        }
      })
      .catch(() => {
        if (!cancelled) setHeaderProfilePicUrl(null);
      });
    return () => { cancelled = true; };
  }, []);

  // Search and sort state for Files section
  const [searchQuery, setSearchQuery] = useState("");
  const [sortSelected, setSortSelected] = useState("");

  // Search state for Secrets section
  const [secretsSearchQuery, setSecretsSearchQuery] = useState("");

  // Search state for Settings section
  const [settingsSearchQuery, setSettingsSearchQuery] = useState("");
  const [manageTeamSearchQuery, setManageTeamSearchQuery] = useState("");
  const [manageRoleSearchQuery, setManageRoleSearchQuery] = useState("");
  const [manageUserState, setManageUserState] = useState("");
  const [isSortRotated, setIsSortRotated] = useState(false);
  const [showAddFileDropdown, setShowAddFileDropdown] = useState(false);
  const [layout, setLayout] = useState("table");
  const addFileDropdownRef = useRef(null);

  // New file modal state
  const [showNewFileModal, setShowNewFileModal] = useState(false);
  const [newFileType, setNewFileType] = useState("doc");

  const showToast = useToast();

  const [canRenewPlan, setCanRenewPlan] = useState(false);
  const [isPlanExpired, setIsPlanExpired] = useState(false);

  // Navbar icon states
  const [viewMode, setViewMode] = useState("table");
  const [downloadMenuOpen, setDownloadMenuOpen] = useState(false);

  // Listen for Ysentinel data updates
  useEffect(() => {
    const handleYsentinelDataUpdate = (event) => {
      const hasData = event.detail?.hasData || false;
      setHasYsentinelData(hasData);
    };

    window.addEventListener("ysentinelDataUpdate", handleYsentinelDataUpdate);

    return () => {
      window.removeEventListener("ysentinelDataUpdate", handleYsentinelDataUpdate);
    };
  }, []);

  // Renew card visibility: show for org admin + individual paid; hide for org user (Employee) and individual free
  useEffect(() => {
    const upgradedPlanId =
      location.state?.upgradedPlanId != null
        ? Number(location.state.upgradedPlanId)
        : null;

    const effectivePlanId =
      upgradedPlanId != null ? upgradedPlanId : backendPlanId;

    // Organisation user (Employee only; org admin is different) → never show renew
    const isOrganisationUser =
      backendIsIndividual === false && backendIsOrgAdmin === false;

    if (effectivePlanId == null || effectivePlanId === 0) {
      setCanRenewPlan(false);
      setIsPlanExpired(false);
      return;
    }

    if (backendPlanExpiry != null) {
      // Assuming plan expiry could be in seconds or milliseconds
      const expiryMs =
        backendPlanExpiry < 1e12 ? backendPlanExpiry * 1000 : backendPlanExpiry;
      
      const expiryDate = new Date(expiryMs);
      const now = new Date();
      const diffTime = expiryDate.getTime() - now.getTime();
      const diffDays = diffTime / (1000 * 60 * 60 * 24);

      setIsPlanExpired(diffDays < 0);

      if (isOrganisationUser) {
        setCanRenewPlan(false);
        return;
      }

      // Show the card if 2 days or less are remaining
      if (diffDays <= 2) {
        setCanRenewPlan(true);
      } else {
        setCanRenewPlan(false);
      }
    } else {
      // If no explicit expiry info, assume false, especially if just upgraded
      setCanRenewPlan(false);
      setIsPlanExpired(false);
    }
  }, [location.state?.upgradedPlanId, backendPlanId, backendIsIndividual, backendIsOrgAdmin, backendPlanExpiry]);

  // Handle download menu close on outside click
  useEffect(() => {
    const onDocClick = () => setDownloadMenuOpen(false);
    if (downloadMenuOpen) document.addEventListener("click", onDocClick);
    return () => document.removeEventListener("click", onDocClick);
  }, [downloadMenuOpen]);

  // Add File dropdown options
  const addNewDropDownOptions = [
    {
      title: "Create Folder",
      onClick: () => { }
    },
    {
      title: "Upload File",
      onClick: () => { }
    },
    {
      title: "Upload Folder",
      onClick: () => { }
    },
    {
      title: "New Doc",
      onClick: () => handleNewFile("doc")
    },
    {
      title: "New Sheet",
      onClick: () => handleNewFile("sheet")
    }
  ];

  const handleNewFile = (type) => {
    // Both doc and sheet now skip the modal
    if (type === "doc" || type === "sheet") {
      const currentFolder = window.filesWrapperProps?.path || [];
      const parentPath = currentFolder.length === 0 ? "/" : `/${currentFolder.join("/")}`;

      const extension = type === 'doc' ? '.idoc' : '.isheet';
      const defaultName = type === 'doc' ? 'Untitled.idoc' : 'Untitled.isheet';

      window.dispatchEvent(new CustomEvent('createNewFile', {
        detail: {
          type: type,
          fileName: defaultName,
          parentPath: parentPath
        }
      }));
      setShowAddFileDropdown(false);
      return;
    }

    setNewFileType(type);
    setShowNewFileModal(true);
    setShowAddFileDropdown(false);
  };

  // Sort options for Files section
  const sortOptions = ["Name", "Type", "File Size", "Created Date", "Modified Date"];

  // Search and sort handlers
  const handleSearchQuery = (e) => {
    setSearchQuery(e.target.value);
  };

  const clearSearchQuery = () => {
    setSearchQuery("");
  };

  const handleSettingsSearchQuery = (e) => {
    setSettingsSearchQuery(e.target.value);
  };

  const clearSettingsSearchQuery = () => {
    setSettingsSearchQuery("");
  };

  const handleManageTeamSearchQuery = (e) => {
    setManageTeamSearchQuery(e.target.value);
  };

  const clearManageTeamSearchQuery = () => {
    setManageTeamSearchQuery("");
  };

  const handleManageRoleSearchQuery = (e) => {
    setManageRoleSearchQuery(e.target.value);
  };

  const clearManageRoleSearchQuery = () => {
    setManageRoleSearchQuery("");
  };

  const handleManageUserChange = (newState) => {
    setManageUserState(newState);
  };

  const handleInviteUsers = () => {
    if (window.inviteUsersHandler) {
      window.inviteUsersHandler();
    }
  };

  const handleAddTeam = () => {
    if (window.addTeamHandler) {
      window.addTeamHandler();
    }
  };

  const handleAddRole = () => {
    if (window.addRoleHandler) {
      window.addRoleHandler();
    }
  };

  const handleAddFile = (event) => {
    if (event) {
      event.stopPropagation();
    }
    if (window.addFileHandler) {
      window.addFileHandler();
    }
    setShowAddFileDropdown(!showAddFileDropdown);
  };

  // Reset search and sort when switching away from Files tab
  useEffect(() => {
    if (activeCard !== 0) {
      setSearchQuery("");
      setSortSelected("");
      setIsSortRotated(false);
      setShowAddFileDropdown(false);
    }
  }, [activeCard]);

  // Reset Secrets search when switching away from Secrets tab
  useEffect(() => {
    if (activeCard !== 1) {
      setSecretsSearchQuery("");
    }
  }, [activeCard]);

  // Handlers for Secrets search
  const handleSecretsSearchQuery = (e) => {
    setSecretsSearchQuery(e.target.value);
  };

  const clearSecretsSearchQuery = () => {
    setSecretsSearchQuery("");
  };

  // Handle click outside to close dropdown
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (showAddFileDropdown &&
        addFileDropdownRef.current &&
        !addFileDropdownRef.current.contains(event.target)) {
        setShowAddFileDropdown(false);
      }
    };

    if (showAddFileDropdown) {
      document.addEventListener("click", handleClickOutside, true);
    }

    return () => {
      document.removeEventListener("click", handleClickOutside, true);
    };
  }, [showAddFileDropdown]);

  // Reset Settings search when closing Settings
  useEffect(() => {
    if (!setting) {
      setSettingsSearchQuery("");
      setManageTeamSearchQuery("");
      setManageRoleSearchQuery("");
      setManageUserState("");
    }
  }, [setting]);

  const isMobile = useScreenMobile({ size: 992 });

  // Function to clear YsentinalOne history
  const clearYsentinalHistory = () => {
    setYsentinalHistory([]);
    setHasYsentinelData(false);
  };

  useEffect(() => {
    sessionStorage.setItem("activeCard", activeCard);
  }, [activeCard]);

  const profileRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        profileRef.current &&
        !profileRef.current.contains(event.target) &&
        !isMobile
      ) {
        setProfile(false);
      }
    };

    if (profile) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [profile]);

  // Persist post-upgrade plan so Ysentinel stays visible when user navigates away and back
  // (e.g. state is lost on reload or when coming back to /homepage without state).
  const YSENTINEL_SESSION_PLAN_KEY = "ysentinelUpgradedPlanId";
  useEffect(() => {
    const id = location.state?.upgradedPlanId;
    if (id === 6 || id === 7) {
      sessionStorage.setItem(YSENTINEL_SESSION_PLAN_KEY, String(id));
    }
  }, [location.state?.upgradedPlanId]);

  // Fetch user from backend for Ysentinel visibility (no sessionStorage for plan)
  // Plan 6 = Pro, Plan 7 = Ultra Pro -> show Ysentinel for individual.
  // Organisation visibility: only Organisation (Organization instance / SuperAdmin) should see Ysentinel.
  useEffect(() => {
    let cancelled = false;
    const readSessionOperations = () => {
      try {
        const raw = sessionStorage.getItem(USER_OPS_SESSION_KEY);
        if (!raw) return [];
        const parsed = JSON.parse(raw);
        return Array.isArray(parsed) ? parsed : [];
      } catch (_) {
        return [];
      }
    };

    const updateOperations = (ops) => {
      const rawOps = Array.isArray(ops) ? ops : [];
      setBackendOperations((prev) => {
        // Prevent flicker: do not replace valid permissions with transient empty reads.
        if (rawOps.length === 0 && Array.isArray(prev) && prev.length > 0) {
          return prev;
        }
        return rawOps;
      });
      try {
        sessionStorage.setItem(USER_OPS_SESSION_KEY, JSON.stringify(rawOps));
      } catch (_) {
        // Ignore cache write failures
      }
    };

    const loadUserForYsentinel = async () => {
      const mail = sessionStorage.getItem("mail");
      if (!mail) {
        setBackendIsIndividual(null);
        setBackendPlanId(null);
        setBackendIsOrgAdmin(null);
        try {
          sessionStorage.removeItem(YSENTINEL_SESSION_PLAN_KEY);
        } catch (_) { /* ignore */ }
        return;
      }
      try {
        const user = await ManageUser.getUserDetails(mail, true);
        if (cancelled || !user) return;
        const planId = typeof user.getPlan === "function" ? user.getPlan() : null;
        let planExpiryRaw = typeof user.getPlanExpiry === "function" ? user.getPlanExpiry() : null;
        if (planExpiryRaw != null && typeof planExpiryRaw.toNumber === "function") {
          planExpiryRaw = planExpiryRaw.toNumber();
        } else if (planExpiryRaw != null) {
          planExpiryRaw = Number(planExpiryRaw);
        }
        
        // Resolve user type robustly. `usertype` in session is set during signin
        // (SuperAdmin/Employee/User) and is more reliable for feature gating.
        const sessionUserType = String(sessionStorage.getItem("usertype") || "").trim();
        const isOrgAdmin =
          user instanceof Organization || sessionUserType === "SuperAdmin";
        const isOrganisationEmployee = sessionUserType === "Employee";
        const isIndividual = !isOrgAdmin && !isOrganisationEmployee;
        const numPlanId = planId != null ? Number(planId) : null;
        setBackendPlanId(numPlanId);
        setBackendPlanExpiry(planExpiryRaw);
        setBackendIsIndividual(isIndividual);
        setBackendIsOrgAdmin(isOrgAdmin);
        const liveOps =
          typeof user.getOperations === "function" ? user.getOperations() || [] : [];
        updateOperations(
          liveOps.length > 0 ? liveOps : readSessionOperations()
        );
        if (isIndividual && (numPlanId === 6 || numPlanId === 7)) {
          try {
            sessionStorage.removeItem(YSENTINEL_SESSION_PLAN_KEY);
          } catch (_) { /* ignore */ }
        }
        if (process.env.NODE_ENV !== "production") {
          console.log(
            "🔍 Ysentinel (backend): planId",
            planId,
            "isIndividual",
            isIndividual,
            "isOrgAdmin",
            isOrgAdmin,
            "showYsentinel",
            isOrgAdmin || (isIndividual && (numPlanId === 6 || numPlanId === 7)) || (!isIndividual && !isOrgAdmin && (user.getOperations() || []).includes(121))
          );
        }
      } catch (e) {
        if (!cancelled) {
          setBackendPlanId(null);
          setBackendPlanExpiry(null);
          setBackendIsIndividual(null);
          setBackendIsOrgAdmin(null);
          updateOperations(readSessionOperations());
        }
      }
    };
    loadUserForYsentinel();
    return () => { cancelled = true; };
  }, []);

  // After upgrade: refetch user with forceRefresh so cache has new planId; refetch storage so limit updates immediately.
  useEffect(() => {
    const fromUpgrade = location.state?.fromUpgrade === true;
    if (!fromUpgrade || didRefetchAfterUpgrade.current) return;
    const mail = sessionStorage.getItem("mail");
    if (!mail) return;
    didRefetchAfterUpgrade.current = true;
    const refetchPlan = async () => {
      try {
        const user = await ManageUser.getUserDetails(mail, true);
        if (!user) return;
        const planId = typeof user.getPlan === "function" ? user.getPlan() : null;
        const sessionUserType = String(sessionStorage.getItem("usertype") || "").trim();
        const isOrgAdmin =
          user instanceof Organization || sessionUserType === "SuperAdmin";
        const isOrganisationEmployee = sessionUserType === "Employee";
        const isIndividual = !isOrgAdmin && !isOrganisationEmployee;
        
        let planExpiryRaw = typeof user.getPlanExpiry === "function" ? user.getPlanExpiry() : null;
        if (planExpiryRaw != null && typeof planExpiryRaw.toNumber === "function") {
          planExpiryRaw = planExpiryRaw.toNumber();
        } else if (planExpiryRaw != null) {
          planExpiryRaw = Number(planExpiryRaw);
        }

        setBackendPlanId(planId != null ? Number(planId) : null);
        setBackendPlanExpiry(planExpiryRaw);
        setBackendIsIndividual(isIndividual);
        setBackendIsOrgAdmin(isOrgAdmin);
        const rawOps =
          typeof user.getOperations === "function" ? user.getOperations() || [] : [];
        setBackendOperations((prev) => {
          if (rawOps.length === 0 && Array.isArray(prev) && prev.length > 0) {
            return prev;
          }
          return rawOps;
        });
        try {
          sessionStorage.setItem(USER_OPS_SESSION_KEY, JSON.stringify(rawOps));
        } catch (_) {
          // Ignore cache write failures
        }
        if (planId != null) sessionStorage.setItem("planId", String(planId));
        window.dispatchEvent(new CustomEvent("planUpgraded"));
      } catch (_) { /* ignore */ }
    };
    window.dispatchEvent(new CustomEvent("planUpgraded"));
    const t1 = setTimeout(refetchPlan, 1500);
    const t2 = setTimeout(refetchPlan, 3500);
    return () => { clearTimeout(t1); clearTimeout(t2); };
  }, [location.state?.fromUpgrade]);

  // Ysentinel visibility: backend + immediate post-upgrade + session fallback when state is lost.
  // When we land from upgrade, location.state.upgradedPlanId is the plan we just paid for —
  // use it immediately so Ysentinel shows without refresh/re-login. If user navigates away and
  // back (or reloads), state can be lost; use sessionStorage fallback so Ysentinel stays visible.
  const upgradedPlanFromState = location.state?.upgradedPlanId != null ? Number(location.state.upgradedPlanId) : null;
  const upgradedPlanFromSession = (() => {
    try {
      const s = sessionStorage.getItem(YSENTINEL_SESSION_PLAN_KEY);
      return s ? Number(s) : null;
    } catch (_) {
      return null;
    }
  })();
  const planIdForYsentinel = upgradedPlanFromState ?? (upgradedPlanFromSession === 6 || upgradedPlanFromSession === 7 ? upgradedPlanFromSession : null) ?? backendPlanId;
  const isIndividualForYsentinel = upgradedPlanFromState != null || upgradedPlanFromSession === 6 || upgradedPlanFromSession === 7
    ? true
    : backendIsIndividual;
  const isOrgAdminForYsentinel = backendIsOrgAdmin === true;
  const isOrganisationUser = backendIsIndividual === false && backendIsOrgAdmin === false;
  const isIndividualUser = isIndividualForYsentinel === true;
  const hasProOrUltraPro = isIndividualUser && (planIdForYsentinel === 6 || planIdForYsentinel === 7);
  const taskManager = useRef(new TaskManager()).current;

  // Backend operation payloads can vary by SDK/server version.
  // Normalize both ids and names defensively so feature gates remain stable.
  const getNumberishOperationValue = (op) => {
    if (op == null) return NaN;
    if (typeof op === "number" || typeof op === "string" || typeof op === "bigint") {
      return Number(op);
    }
    if (typeof op === "object") {
      const candidateKeys = ["id", "role", "op", "operation", "permission", "value", "code"];
      for (const key of candidateKeys) {
        if (!(key in op)) continue;
        const value = op[key];
        if (value == null) continue;
        if (typeof value === "number" || typeof value === "string" || typeof value === "bigint") {
          return Number(value);
        }
        if (typeof value?.toNumber === "function") {
          return Number(value.toNumber());
        }
      }
    }
    return NaN;
  };

  const getStringOperationValue = (op) => {
    if (typeof op === "string") return op.trim();
    if (!op || typeof op !== "object") return "";
    const candidateKeys = ["name", "role", "op", "operation", "permission", "title"];
    for (const key of candidateKeys) {
      const value = op[key];
      if (typeof value === "string" && value.trim()) return value.trim();
    }
    return "";
  };

  const normalizedOperationIds = (backendOperations || [])
    .map((op) => getNumberishOperationValue(op))
    .filter((n) => Number.isFinite(n));

  const normalizedOperationNames = (backendOperations || [])
    .map((op) => getStringOperationValue(op))
    .filter(Boolean);

  const hasOperation = (opId) => normalizedOperationIds.includes(Number(opId));
  const hasOperationName = (opName) => normalizedOperationNames.includes(String(opName));
  const resolvePermissionId = (permissionName, fallbackId) => {
    const sdkId = getPermissionNumber(permissionName);
    return Number.isFinite(sdkId) && sdkId >= 0 ? sdkId : fallbackId;
  };
  const YSENTINEL_PERMISSION_ID = resolvePermissionId("YSentinel", 121);
  const LIST_FILES_PERMISSION_ID = resolvePermissionId("ListFiles", 25);
  const LIST_PINS_PERMISSION_ID = resolvePermissionId("ListPins", 91);
  const SPACE_OPERATION_IDS = [
    resolvePermissionId("AddSpace", 97),
    resolvePermissionId("AddUserToSpace", 98),
    resolvePermissionId("RemoveUserFromSpace", 99),
    resolvePermissionId("UpdatePermissionsOfSpace", 100),
    resolvePermissionId("AddObjectToSpace", 101),
    resolvePermissionId("RemoveObjectFromSpace", 102),
    resolvePermissionId("RemoveSpace", 103),
    resolvePermissionId("SendOtpToExternalUser", 104),
    resolvePermissionId("SignInToSpace", 105),
    resolvePermissionId("ListSpaces", 106),
  ];

  const hasYsentinelPermission =
    !isOrganisationUser ||
    hasOperation(YSENTINEL_PERMISSION_ID) ||
    hasOperationName("YSentinel");
  const hasFilesPermission =
    !isOrganisationUser ||
    hasOperation(LIST_FILES_PERMISSION_ID) ||
    hasOperationName("ListFiles") ||
    hasOperationName("Files") ||
    hasOperationName("File");
  const hasPinsPermission =
    !isOrganisationUser ||
    hasOperation(LIST_PINS_PERMISSION_ID) ||
    hasOperationName("ListPins") ||
    hasOperationName("Pins") ||
    hasOperationName("Pin");
  const shouldShowLogs =
    !isOrganisationUser &&
    (backendIsOrgAdmin === true || backendIsIndividual === true);
  // const hasLogsPermission = !isOrganisationUser || hasOperation(65);
  const SPACE_OPERATION_NAMES = [
    "AddSpace",
    "AddUserToSpace",
    "RemoveUserFromSpace",
    "UpdatePermissionsOfSpace",
    "AddObjectToSpace",
    "RemoveObjectFromSpace",
    "RemoveSpace",
    "SendOtpToExternalUser",
    "SignInToSpace",
    "ListSpaces"
  ];
  const hasSpacePermission =
    !isOrganisationUser ||
    SPACE_OPERATION_IDS.some((opId) => hasOperation(opId)) ||
    SPACE_OPERATION_NAMES.some((opName) => hasOperationName(opName));

  const shouldShowYsentinel = isOrgAdminForYsentinel || hasProOrUltraPro || (isOrganisationUser && hasYsentinelPermission);
  // ========================================

  // Alerts hidden for now for both individual and organisation; set to false to re-enable.
  const HIDE_ALERTS_FOR_NOW = true;
  // Hide the Locations dashboard for now (feature work in progress).
  // Flip to `false` to re-enable without code changes.
  const HIDE_LOCATIONS_FOR_NOW = true;

  // Show Shared tab only for Organisation and Organisation User; hide for Individual
  const showSharedTab = backendIsIndividual === false;

  // Data array - conditionally includes Ysentinel based on user type and plan
  const data = [
    ...(hasFilesPermission ? [
      <Ysafe
        key={1}
        searchQuery={searchQuery}
        sortSelected={sortSelected}
        isSortRotated={isSortRotated}
        setIsSortRotated={setIsSortRotated}
        layout={layout}
        setLayout={setLayout}
        showSharedTab={showSharedTab}
        backendOperations={backendOperations}
        isOrganisationUser={isOrganisationUser}
        hasSpacePermission={hasSpacePermission}
        taskManager={taskManager}
      />
    ] : []),
    ...(hasPinsPermission ? [
      <SecretManagement key={2} searchQuery={secretsSearchQuery} setActiveCard={setActiveCard} />
    ] : []),

    ...(shouldShowYsentinel ? [
      <YsentinelOne
        compress={compress}
        key={3}
        history={ysentinalHistory}
        setHistory={setYsentinalHistory}
        viewMode={viewMode}
        setViewMode={setViewMode}
        isHistoryOpen={isHistoryOpen}
        setIsHistoryOpen={setIsHistoryOpen}
        profile={profile}
      />,
      <SummaryDashboard   key={7} />,
      <FilesDashboard     key={8} />,
      <UsersDashboard     key={9} />,
      ...(HIDE_LOCATIONS_FOR_NOW ? [] : [<LocationsDashboard key={10} />]),
      ...(HIDE_ALERTS_FOR_NOW ? [] : [<AlertsPage key={4} />]),
      ...(shouldShowLogs ? [<Logs organization={true} key={6} />] : [])
    ] : []),

    ...(hasSpacePermission ? [<Spaces compress={compress} key={5} />] : [])
  ];

  const validActiveCard = activeCard >= 0 && activeCard < data.length ? activeCard : 0;

  useEffect(() => {
    if (activeCard < 0 || activeCard >= data.length) {
      const newActiveCard = 0;
      setActiveCard(newActiveCard);
      localStorage.setItem("activeCard", newActiveCard.toString());
    }
  }, [activeCard, data.length]);

  // Sidebar data - conditionally includes Ysentinel tab based on user type and plan
  const sidebarData = [
    ...(hasFilesPermission ? [{
      title: "Files",
      image: ysafe,
      imageActive: ysafeDark,
      toolTipText: "Files"
    }] : []),
    ...(hasPinsPermission ? [{
      title: "Pins",
      image: passwordManager,
      imageActive: passwordManagerDark,
      toolTipText: "Pins"
    }] : []),

    ...(shouldShowYsentinel ? [{
      title: "Ysentinel ",
      image: reportAnalysis,
      imageActive: reportAnalysisDark,
      toolTipText: "Ysentinel"
    }] : []),

    ...(hasSpacePermission ? [{
      title: "Spaces",
      image: "spacesIconComponent",
      imageActive: "spacesIconComponent",
      toolTipText: "Spaces"
    }] : [])
  ];

  const [showNotifications, setShowNotifications] = useState(false);
  const notificationRef = useRef(null);
  const [allNotifications, setAllNotifications] = useState([]);

  const fetchNotifications = async () => {
    try {
      setAllNotifications([]);
    } catch (error) {
      console.error("Failed to fetch notifications:", error);
      setAllNotifications([]);
    }
  };

  useEffect(() => {
    fetchNotifications();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (isMobile) return;

      if (
        notificationRef.current &&
        !notificationRef.current.contains(event.target)
      ) {
        setShowNotifications(false);
      }
    };

    if (showNotifications) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showNotifications]);

  const [notifications, setNotifications] = useState(allNotifications);
  const [unread, setUnread] = useState(false);

  useEffect(() => {
    const unreadChat = notifications.some((notification) => !notification.read);
    setUnread(unreadChat);
  }, [notifications]);

  useEffect(() => {
    const handleOpenSettings = () => {
      setSetting(true);
    };

    const handleCloseSettingsToProfile = () => {
      setSetting(false);
      setProfile(true);
    };

    window.addEventListener("openSettings", handleOpenSettings);
    document.addEventListener("closeSettingsToProfile", handleCloseSettingsToProfile);

    return () => {
      window.removeEventListener("openSettings", handleOpenSettings);
      document.removeEventListener("closeSettingsToProfile", handleCloseSettingsToProfile);
    };
  }, []);

  // Derive concrete indices from enabled sections instead of React element keys.
  // React keys are internal strings at runtime and can make findIndex() brittle.
  let currentDataIndex = 0;
  const FILES_INDEX = hasFilesPermission ? currentDataIndex++ : -1;
  const PINS_INDEX = hasPinsPermission ? currentDataIndex++ : -1;
  
  const YSENTINEL_ANALYSIS_INDEX = shouldShowYsentinel ? currentDataIndex++ : -1;
  const YSENTINEL_SUMMARY_INDEX = shouldShowYsentinel ? currentDataIndex++ : -1;
  const YSENTINEL_FILES_INDEX = shouldShowYsentinel ? currentDataIndex++ : -1;
  const YSENTINEL_USERS_INDEX = shouldShowYsentinel ? currentDataIndex++ : -1;
  const YSENTINEL_LOCATIONS_INDEX = shouldShowYsentinel && !HIDE_LOCATIONS_FOR_NOW ? currentDataIndex++ : -1;
  const YSENTINEL_ALERTS_INDEX = shouldShowYsentinel && !HIDE_ALERTS_FOR_NOW ? currentDataIndex++ : -1;
  const YSENTINEL_LOGS_INDEX = shouldShowYsentinel && shouldShowLogs ? currentDataIndex++ : -1;
  const SPACES_INDEX = hasSpacePermission ? currentDataIndex++ : -1;

  const ysentinelSectionTabs = [
    { id: "overview", label: "Overview",      index: YSENTINEL_SUMMARY_INDEX },
    { id: "files",    label: "Files",         index: YSENTINEL_FILES_INDEX },
    { id: "users",    label: "Users & teams", index: YSENTINEL_USERS_INDEX },
    ...(HIDE_LOCATIONS_FOR_NOW ? [] : [{ id: "locations", label: "Locations", index: YSENTINEL_LOCATIONS_INDEX }]),
    ...(HIDE_ALERTS_FOR_NOW    ? [] : [{ id: "alerts",    label: "Alerts",    index: YSENTINEL_ALERTS_INDEX }]),
    { id: "analysis", label: "Analysis",      index: YSENTINEL_ANALYSIS_INDEX },
    ...(shouldShowLogs ? [{ id: "logs", label: "Logs", index: YSENTINEL_LOGS_INDEX }] : []),
  ].filter(t => t.index >= 0);

  return (
    <section className={`Homepage ${isMobile && activeCard === YSENTINEL_ANALYSIS_INDEX ? "ysentinel-analysis ysentinel-view-sticky" : ""} ${backendIsIndividual ? "individual-user" : ""}`}>
      <div className="container HomepageContainer">
        {isMobile && (
          <div
            className={dropdown ? "overlays" : ""}
            onClick={() => setDropdown(false)}
          ></div>
        )}
        <div
          className={`HomepageSidebar ${isMobile && dropdown ? " HomepageShowSidebar" : isMobile ? "HomepageHideSidebar" : ""} ${compress ? "HomepageCompressSiderbar" : ""}`}
          style={{
            width: isMobile ? "50%" : compress ? "5.49%" : "16.6667%"
          }}
        >
          {isMobile && (
            <div className="mobile-sidebar-header">
              <div className="mobile-logo">
                <img src={theme === "light" ? logo : logoDark} alt="Induz" />
              </div>
              <div
                className="mobile-sidebar-close"
                onClick={(e) => {
                  e.stopPropagation();
                  setDropdown(false);
                }}
              >
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                >
                  <path
                    d="M18 6L6 18"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                  <path
                    d="M6 6l12 12"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
            </div>
          )}
          {!isMobile && (
            <div className="HomepageSidebarTop ">
              <div className="Logo ">
                <img
                  src={
                    !compress
                      ? theme === "light"
                        ? logo
                        : logoDark
                      : theme === "light"
                        ? logoIcon
                        : logoIconDark
                  }
                  alt="Induz"
                />
              </div>
              <div
                className={`Image ${!compress ? "" : "ImageCompress"} `}
                onClick={() => setCompress((prev) => !prev)}
              >
                <img
                  src={theme === "light" ? button : buttonDark}
                  alt="close"
                />
              </div>
            </div>
          )}
          <div
            className={`HomepageSidebarContent ${!compress ? "addScroll" : ""}`}
          >
            <div className="HomepageSidebarContentSwitch">
              {sidebarData.map((tab, index) => {
                const isYsentinelTab = (tab.title || "").trim().toLowerCase() === "ysentinel";
                const isSpacesTab = (tab.title || "").trim().toLowerCase() === "spaces";
                const isLogsTab = (tab.title || "").trim().toLowerCase() === "logs";

                let dataIndex = index;
                if (tab.title === "Files") {
                  dataIndex = FILES_INDEX;
                } else if (tab.title === "Pins") {
                  dataIndex = PINS_INDEX;
                } else if (tab.title === "Spaces") {
                  dataIndex = SPACES_INDEX;
                } else if (isYsentinelTab) {
                  dataIndex = YSENTINEL_ANALYSIS_INDEX;
                } else if (isLogsTab) {
                  dataIndex = YSENTINEL_LOGS_INDEX;
                }

                const isActive =
                  (activeCard === dataIndex ||
                    (isYsentinelTab && (
                      activeCard === YSENTINEL_ANALYSIS_INDEX ||
                      activeCard === YSENTINEL_ALERTS_INDEX ||
                      activeCard === YSENTINEL_LOGS_INDEX ||
                      activeCard === YSENTINEL_SUMMARY_INDEX ||
                      activeCard === YSENTINEL_FILES_INDEX ||
                      activeCard === YSENTINEL_USERS_INDEX ||
                      activeCard === YSENTINEL_LOCATIONS_INDEX
                    )));

                const tabContent = (
                  <div
                    className={`HomepageSidebarContentTabs ${isActive
                      ? theme === "light"
                        ? "HomepageSidebarContentactiveTab"
                        : "HomepageSidebarContentactiveTabDark"
                      : ""
                      } ${theme === "light" ? "" : "activeTabsDark"}`}
                    key={index}
                    style={isYsentinelTab || tab.title === "Spaces" ? { display: "flex", flexDirection: "column", alignItems: "stretch", justifyContent: "flex-start", gap: "6px" } : undefined}
                    onMouseEnter={() => {
                      if (isSpacesTab && !compress) {
                        setSpacesHover(true);
                      }
                    }}
                    onMouseLeave={() => {
                      if (isSpacesTab && !compress) {
                        setSpacesHover(false);
                      }
                    }}
                    onClick={() => {
                      if (isYsentinelTab) {
                        const firstTab = ysentinelSectionTabs[0];
                        if (firstTab) setActiveCard(firstTab.index);
                        setDropdown(false);
                      } else {
                        if (tab.title === "Files" && FILES_INDEX !== -1) {
                          setActiveCard(FILES_INDEX);
                        } else if (tab.title === "Pins" && PINS_INDEX !== -1) {
                          setActiveCard(PINS_INDEX);
                        } else if (tab.title === "Spaces" && SPACES_INDEX !== -1) {
                          setActiveCard(SPACES_INDEX);
                        } else {
                          setActiveCard(dataIndex);
                        }
                        setDropdown(false);
                      }
                      setProfile(false);

                      if (setting) {
                        sessionStorage.removeItem("activeTab");
                      }

                      setSetting(false);
                    }}
                  >
                    <div className="tab" style={{ display: "flex", alignItems: "center", justifyContent: "space-between", width: "100%" }}>
                      <div style={{ display: "flex", alignItems: "center", gap: "10px" }}>
                        {tab.image === "spacesIconComponent" ? (
                          <SpacesIcon isActive={isActive} theme={theme} />
                        ) : (
                          <img
                            src={
                              isActive ? tab.imageActive : tab.image
                            }
                            alt="tab-icon"
                          />
                        )}
                        {!compress && <p>{tab.title}</p>}
                      </div>

                    </div>


                    {isSpacesTab && spacesHover && !compress && (
                      <div className="HomepageSidebarSubMenu" style={{ marginTop: "4px" }}>
                        <div
                          className="HoempageSidebarSubTab"
                          style={{ cursor: "pointer", opacity: 0.7 }}
                          onMouseEnter={(e) => {
                            e.currentTarget.style.opacity = "1";
                            e.currentTarget.style.backgroundColor = "var(--fill-brand-light)";
                          }}
                          onMouseLeave={(e) => {
                            e.currentTarget.style.opacity = "0.7";
                            e.currentTarget.style.backgroundColor = "transparent";
                          }}
                          onClick={(e) => {
                            e.stopPropagation();
                            setDropdown(false);
                            setProfile(false);
                          }}
                        >
                          External sharing
                        </div>
                      </div>
                    )}

                    {tab.title === "Secure IAM" && !compress && (
                      <div>
                        <img src={downArrow} alt="downArrow" />
                      </div>
                    )}
                  </div>
                );

                return compress ? (
                  <Tooltip text={tab.toolTipText} position="right">
                    {tabContent}
                  </Tooltip>
                ) : (
                  tabContent
                );
              })}
            </div>
            {!compress && (
              <div className="HomepageSidebarContentBottom">
                {canRenewPlan && showRenewalCard && (
                  <div className="HomepageSidebarContentButtomDownload">
                    <RenewalCard onClose={() => setShowRenewalCard(false)} />
                  </div>
                )}
                {/* {download && (
                  <div className="HomepageSidebarContentButtomDownload">
                    <Download setDownload={setDownload} compress={compress} />
                  </div>
                )} */}

              </div>
            )}
          </div>
        </div>

        <div className={`HomepageWrapper ${compress ? "compressWrapper" : ""}`}>
          <div className="HomepageWrapperHead">
            {!isMobile && <div className="HomepageWrapperHeadTrial"></div>}

            {isMobile && (
              <div className="mobile-navbar-rows" style={{ width: "100%" }}>
                {/* Row 1: Menu, Tabs, Timer, Profile */}
                <div className="mobile-navbar-row row-1" style={{ display: "flex", alignItems: "center", width: "100%" }}>
                  {/* Menu Button */}
                  <button
                    className={`mobile-menu-button ${dropdown ? "menu-open" : ""}`}
                    onClick={(e) => {
                      e.stopPropagation();
                      setDropdown(true);
                    }}
                    aria-label="Open menu"
                  >
                    <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor">
                      <path d="M3 12H21" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M3 6H21" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                      <path d="M3 18H21" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                    </svg>
                  </button>

                  {/* Spacer to push items to the right */}
                  <div className="mobile-header-spacer" style={{ flex: 1 }}></div>

                  {/* Tabs (Files Only) */}
                  {!setting && activeCard === FILES_INDEX && (
                    <div className="headerLeftSection" style={{ overflowX: "auto", margin: "0 2px" }}>
                      <div className="fileTextTabs">
                        <div
                          className={`fileTab ${filesActiveTab === 0 ? "active" : ""}`}
                          onClick={() => window.filesWrapperProps?.switchSection?.(0) || window.filesWrapperProps?.setActiveTab?.(0)}
                        >
                          <TabIcons type="allFiles" size={18} color={filesActiveTab === 0 ? "var(--text-highlight)" : "var(--text-grey-strong)"} />
                          <span>Own</span>
                        </div>
                        {showSharedTab && (
                          <div
                            className={`fileTab ${filesActiveTab === 1 ? "active" : ""}`}
                            onClick={() => window.filesWrapperProps?.switchSection?.(1) || window.filesWrapperProps?.setActiveTab?.(1)}
                          >
                            <TabIcons type="shared" size={18} color={filesActiveTab === 1 ? "var(--text-highlight)" : "var(--text-grey-strong)"} />
                            <span>Shared</span>
                          </div>
                        )}
                        <div
                          className={`fileTab ${filesActiveTab === 2 ? "active" : ""}`}
                          onClick={() => window.filesWrapperProps?.switchSection?.(2) || window.filesWrapperProps?.setActiveTab?.(2)}
                        >
                          <TabIcons type="trash" size={18} color={filesActiveTab === 2 ? "var(--text-highlight)" : "var(--text-grey-strong)"} />
                          <span style={{ display: "inline-block", marginLeft: "2px" }}>Trash</span>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Pins Search in Row 1 (Mobile) */}
                  {!setting && activeCard === PINS_INDEX && (
                    <div className="mobile-pins-header-search" style={{ margin: "0 2px", minWidth: 0 }}>
                      <div className="searchInput" style={{ width: "100%" }}>
                        <Input
                          searchIconBool={true}
                          placeholder="Search PINS"
                          value={secretsSearchQuery}
                          onChange={handleSecretsSearchQuery}
                          clear={secretsSearchQuery && true}
                          handleClear={clearSecretsSearchQuery}
                          bg={theme === "light" ? "#fff" : "transparent"}
                          height="28px"
                          fontSize="12px"
                        />
                      </div>
                    </div>
                  )}

                  {/* Ysentinel Icons (Mobile) */}
                  {!setting && activeCard === YSENTINEL_ANALYSIS_INDEX && hasYsentinelData && (
                    <div className="mobile-ysentinel-header-icons" style={{ display: "flex", justifyContent: "flex-end", gap: "2px", margin: "0 4px" }}>
                      <div className="top-navbar" style={{ display: "flex", alignItems: "center", gap: "4px" }}>
                        <div className="top-navbar-right">
                          <button
                            type="button"
                            className="filter-toggle-btn"
                            onClick={(e) => {
                              e.stopPropagation();
                              document.dispatchEvent(new CustomEvent("toggleFilters"));
                            }}
                          >
                            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
                              <path d="M22 4H2l8 9v7l4 2v-9l8-9z" strokeLinecap="round" strokeLinejoin="round" />
                            </svg>
                          </button>

                          <button
                            type="button"
                            onClick={() => setViewMode("table")}
                            className={`view-toggle-btn ${viewMode === "table" ? "active" : ""}`}
                          >
                            <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
                              <rect x="3.5" y="3.5" width="17" height="17" rx="2" />
                              <path d="M3.5 9.5h17M3.5 14.5h17M9.5 3.5v17" />
                            </svg>
                          </button>

                          <div className="charts-download-wrapper" style={{ position: "relative" }}>
                            <button
                              type="button"
                              className="charts-download-btn"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                document.dispatchEvent(new CustomEvent("downloadCharts", { detail: { format: "csv" } }));
                                showToast("Download successful", "success");
                              }}
                            >
                              <svg viewBox="0 0 24 24" width="16" height="16" fill="none" stroke="currentColor" strokeWidth="2">
                                <path d="M12 3v12M8 11l4 4 4-4" strokeLinecap="round" strokeLinejoin="round" />
                                <rect x="4" y="17" width="16" height="3" rx="1" />
                              </svg>
                            </button>
                          </div>
                        </div>
                      </div>
                    </div>
                  )}

                  {/* Settings Search in Row 1 (Mobile) */}
                  {setting && (manageUserState === "manageUser" || manageUserState === "manageTeam" || manageUserState === "manageRole") && (
                    <div className="mobile-settings-header-actions" style={{ display: "flex", alignItems: "center", gap: "4px", margin: "0 4px", minWidth: 0 }}>
                      <div className="searchInput" style={{ minWidth: 0 }}>
                        <Input
                          searchIconBool={true}
                          placeholder={
                            manageUserState === "manageUser"
                              ? "Search Users"
                              : manageUserState === "manageTeam"
                                ? "Search Teams"
                                : "Search Roles"
                          }
                          value={
                            manageUserState === "manageUser"
                              ? settingsSearchQuery
                              : manageUserState === "manageTeam"
                                ? manageTeamSearchQuery
                                : manageRoleSearchQuery
                          }
                          onChange={
                            manageUserState === "manageUser"
                              ? handleSettingsSearchQuery
                              : manageUserState === "manageTeam"
                                ? handleManageTeamSearchQuery
                                : handleManageRoleSearchQuery
                          }
                          clear={true}
                          handleClear={
                            manageUserState === "manageUser"
                              ? clearSettingsSearchQuery
                              : manageUserState === "manageTeam"
                                ? clearManageTeamSearchQuery
                                : clearManageRoleSearchQuery
                          }
                          bg={theme === "light" ? "#fff" : "transparent"}
                        />
                      </div>
                    </div>
                  )}

                  {/* Right Icons: Add Button (Settings Only) + Timer (Operation Panel) + Profile */}
                  <div className="mobile-row-right-icons" style={{ display: "flex", alignItems: "center", gap: "2px", flexShrink: 0 }}>
                    {/* Settings Add Button (Mobile Row 1 Right) */}
                    {setting && (manageUserState === "manageUser" || manageUserState === "manageTeam" || manageUserState === "manageRole") && (
                      <Button
                        title={manageUserState === "manageTeam" ? "+ Team" : manageUserState === "manageRole" ? "+ Role" : "+ Add"}
                        type="violet"
                        padding="0 8px"
                        fontSize="10px"
                        width="fit-content"
                        height="28px"
                        onClick={
                          manageUserState === "manageUser"
                            ? handleInviteUsers
                            : manageUserState === "manageTeam"
                              ? handleAddTeam
                              : handleAddRole
                        }
                      />
                    )}
                    {/* Pins Add Button (Mobile Row 1 Right) */}
                    {!setting && activeCard === PINS_INDEX && (
                      <Button
                        title="+ Add"
                        type="violet"
                        padding="0 8px"
                        fontSize="10px"
                        width="fit-content"
                        height="28px"
                        onClick={() => {
                          if (window.secretsManagementProps?.handleCreateSecretModal) {
                            window.secretsManagementProps.handleCreateSecretModal();
                          }
                        }}
                      />
                    )}
                    {/* Timer Icon (Operation Panel Toggle) */}
                    {!setting && activeCard === FILES_INDEX && (
                      <div
                        className="bellIcon operationPanelToggle"
                        onClick={() => {
                          document.dispatchEvent(new CustomEvent("toggleOperationPanel"));
                          setProfile(false);
                          setShowNotifications(false);
                        }}
                        title="Toggle Operation Panel"
                        style={{ display: "flex", alignItems: "center", justifyContent: "center" }}
                      >
                        <div className="svg" style={{ display: "flex" }}>
                          <svg
                            width="24"
                            height="24"
                            viewBox="0 0 24 24"
                            fill="none"
                            xmlns="http://www.w3.org/2000/svg"
                          >
                            <path
                              d="M12 8V12L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z"
                              stroke={theme === "light" ? "#7D708A" : "#BDB8C2"}
                              strokeWidth="1.5"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                            />
                          </svg>
                        </div>
                      </div>
                    )}

                    {/* Profile Icon */}
                    <div className="arrow" ref={profileRef} style={{ display: "flex", flexDirection: "column", alignItems: "center", gap: "8px" }}>
                      <span className={theme === "dark" ? "spanDark" : ""} onClick={() => setProfile(true)}>
                        {headerProfilePicUrl ? (
                          <img src={headerProfilePicUrl} alt="Profile" className="header-profile-pic" />
                        ) : (
                          sessionStorage.getItem("mail") === null ? "@" : sessionStorage.getItem("mail")[0].toUpperCase()
                        )}
                      </span>
                      {activeCard === data.length - 1 && (
                        <div
                          className="close-spaces-mobile"
                          onClick={(e) => {
                            e.stopPropagation();
                            setActiveCard(0); // Go to Files
                          }}
                          style={{
                            cursor: "pointer",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            marginTop: "0px"
                          }}
                        >
                          <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M18 6L6 18" stroke={theme === "light" ? "#555F75" : "#9CA3AF"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                            <path d="M6 6L18 18" stroke={theme === "light" ? "#555F75" : "#9CA3AF"} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                        </div>
                      )}
                      {profile && (
                        <Profile
                          setSettings={setSetting}
                          settings={setting}
                          setProfile={setProfile}
                          clearYsentinalHistory={clearYsentinalHistory}
                          onProfilePicLoad={setHeaderProfilePicUrl}
                          canRenewPlan={canRenewPlan}
                        />
                      )}
                    </div>
                  </div>
                </div>

                {/* Row 2: Search, Sort, Add - Hidden in Settings if Row 1 actions are active */}
                {(!setting || (!manageUserState || !["manageUser", "manageTeam", "manageRole"].includes(manageUserState))) && activeCard !== YSENTINEL_ANALYSIS_INDEX && (
                  <div className="mobile-navbar-row row-2" style={{ display: "flex", flexDirection: "row", alignItems: "center", width: "100%", gap: "0", justifyContent: "flex-end", padding: "1px 12px" }}>
                    {/* Search: Order 1, Flex Auto (Compact) */}
                    <div className="mobile-top-search" style={{ order: "1", flex: "0 1 auto", minWidth: "0" }}>
                      {!setting && activeCard === FILES_INDEX && (
                        <div className="searchInput">
                          <Input
                            searchIconBool={true}
                            placeholder="Search"
                            value={searchQuery}
                            onChange={handleSearchQuery}
                            clear={searchQuery && true}
                            handleClear={clearSearchQuery}
                            bg={theme === "light" ? "#fff" : "transparent"}
                            height="28px"
                            fontSize="12px"
                          />
                        </div>
                      )}
                      {setting && (manageUserState === "manageUser" || manageUserState === "manageTeam" || manageUserState === "manageRole") && (
                        <div className="searchInput">
                          <Input
                            searchIconBool={true}
                            placeholder={
                              manageUserState === "manageUser"
                                ? "Search User"
                                : manageUserState === "manageTeam"
                                  ? "Search Team"
                                  : manageUserState === "manageRole"
                                    ? "Search Role"
                                    : "Search"
                            }
                            value={
                              manageUserState === "manageUser"
                                ? settingsSearchQuery
                                : manageUserState === "manageTeam"
                                  ? manageTeamSearchQuery
                                  : manageRoleSearchQuery
                            }
                            onChange={
                              manageUserState === "manageUser"
                                ? handleSettingsSearchQuery
                                : manageUserState === "manageTeam"
                                  ? handleManageTeamSearchQuery
                                  : handleManageRoleSearchQuery
                            }
                            clear={true}
                            handleClear={
                              manageUserState === "manageUser"
                                ? clearSettingsSearchQuery
                                : manageUserState === "manageTeam"
                                  ? clearManageTeamSearchQuery
                                  : manageRoleSearchQuery
                            }
                            bg={theme === "light" ? "#fff" : "transparent"}
                          />
                        </div>
                      )}
                    </div>

                    {/* Sort: Order 2, Auto Width */}
                    {!setting && activeCard === FILES_INDEX && (
                      <div className="sortDropdown" style={{ order: "2", flex: "0 0 auto", minWidth: "fit-content", maxWidth: "none" }}>
                        <Dropdown
                          options={sortOptions}
                          placeholder="Sort By"
                          arrowColor={theme === "light" ? "#555F75" : "#A36BD0"}
                          background={theme === "light" ? "#FFF" : "var(--background-bg-dark)"}
                          textColor="var(--text-grey-strong)"
                          itemColor="var(--text-grey-strong)"
                          hoveredColor="var(--fill-brand-light)"
                          selected={sortSelected}
                          setSelected={setSortSelected}
                          height="28px"
                          fontSize="12px"
                        />
                      </div>
                    )}
                    {/* Advanced Search: Order 2.5, only on Own tab */}
                    {!setting && activeCard === FILES_INDEX && filesActiveTab === 0 && (
                      <button
                        className="adv-search-trigger-btn mobile"
                        style={{ order: "2", flex: "0 0 auto" }}
                        onClick={() => setAdvancedSearchOpen(true)}
                        title="Advanced Search"
                      >
                        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                          <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                        </svg>
                      </button>
                    )}

                    {/* Add Button: Order 3 */}
                    <div className="mobile-row-right-actions" style={{ order: "3", display: "flex", alignItems: "center" }}>
                      {!setting && activeCard === FILES_INDEX && (
                        <div className="inviteUsersButton" style={{ position: "relative" }}>
                          <Button
                            title="+ Add"
                            type="violet"
                            width="fit-content"
                            height="28px"
                            fontSize="12px"
                            padding="0 10px"
                            onClick={handleAddFile}
                          />
                          {activeCard === FILES_INDEX && showAddFileDropdown && window.filesWrapperProps && (
                            <div ref={addFileDropdownRef} className="addFileDropdown" style={{ position: "absolute", top: "100%", right: 0, zIndex: 1000 }}>
                              <TextDropDown
                                content={addNewDropDownOptions}
                                width="fit-content"
                                {...window.filesWrapperProps}
                                setIsDropDownVisible={setShowAddFileDropdown}
                                setAddFile={setShowAddFileDropdown}
                              />
                            </div>
                          )}
                        </div>
                      )}
                      {setting && (manageUserState === "manageUser" || manageUserState === "manageTeam" || manageUserState === "manageRole") && (
                        <div className="inviteUsersButton">
                          <Button
                            title={manageUserState === "manageTeam" ? "+ Add Team" : manageUserState === "manageRole" ? "+ Add Role" : "+ Add"}
                            type="violet"
                            width="fit-content"
                            onClick={
                              manageUserState === "manageUser"
                                ? handleInviteUsers
                                : manageUserState === "manageTeam"
                                  ? handleAddTeam
                                  : handleAddRole
                            }
                          />
                        </div>
                      )}
                    </div>
                  </div>
                )}
              </div>
            )}
            {/* Search, Sort, View Toggles, and Add Button - Only show when Files tab is active and not in settings */}
            {!isMobile && activeCard === FILES_INDEX && !setting && (
              <div className="HomepageWrapperHeadSearchSort">
                {/* Left Section: Text Tabs for Files Navigation */}
                <div className="headerLeftSection">
                  <div className="fileTextTabs">
                    <div
                      className={`fileTab ${filesActiveTab === 0 ? "active" : ""}`}
                      onClick={() => window.filesWrapperProps?.switchSection?.(0) || window.filesWrapperProps?.setActiveTab?.(0)}
                    >
                      <TabIcons
                        type="allFiles"
                        size={16}
                        color={filesActiveTab === 0 ? "var(--text-highlight)" : "var(--text-grey-strong)"}
                      />
                      <span>Own</span>
                    </div>
                    {showSharedTab && (
                      <div
                        className={`fileTab ${filesActiveTab === 1 ? "active" : ""}`}
                        onClick={() => window.filesWrapperProps?.switchSection?.(1) || window.filesWrapperProps?.setActiveTab?.(1)}
                      >
                        <TabIcons
                          type="shared"
                          size={16}
                          color={filesActiveTab === 1 ? "var(--text-highlight)" : "var(--text-grey-strong)"}
                        />
                        <span>Shared</span>
                      </div>
                    )}
                    <div
                      className={`fileTab ${filesActiveTab === 2 ? "active" : ""}`}
                      onClick={() => window.filesWrapperProps?.switchSection?.(2) || window.filesWrapperProps?.setActiveTab?.(2)}
                    >
                      <TabIcons
                        type="trash"
                        size={16}
                        color={filesActiveTab === 2 ? "var(--text-highlight)" : "var(--text-grey-strong)"}
                      />
                      <span>Trash</span>
                    </div>
                  </div>
                </div>

                {/* Middle Section: Search and Sort */}
                <div className="headerMiddleSection">
                  <div className="searchInput">
                    <Input
                      searchIconBool={true}
                      placeholder="Search by filename or folder"
                      value={searchQuery}
                      onChange={handleSearchQuery}
                      clear={searchQuery && true}
                      handleClear={clearSearchQuery}
                      bg={theme === "light" ? "#fff" : "transparent"}
                    />
                  </div>
                  <div className="sortDropdown">
                    <Dropdown
                      options={sortOptions}
                      placeholder="Sort by"
                      arrowColor={theme === "light" ? "#555F75" : "#555F75"}
                      background={
                        theme === "light"
                          ? "var(--White,#FFF)"
                          : "var(--background-bg-dark)"
                      }
                      textColor={"var(--text-grey-strong)"}
                      itemColor={"var(--text-grey-strong)"}
                      hoveredColor={
                        theme === "light"
                          ? "var(--fill-brand-light)"
                          : "var(--fill-brand-light)"
                      }
                      selected={sortSelected}
                      setSelected={setSortSelected}
                    />
                  </div>
                  {filesActiveTab === 0 && (
                    <button
                      className={`adv-search-trigger-btn`}
                      onClick={() => setAdvancedSearchOpen(true)}
                      title="Advanced Search"
                    >
                      <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                        <polygon points="22 3 2 3 10 12.46 10 19 14 21 14 12.46 22 3" />
                      </svg>
                    </button>
                  )}
                </div>

                {/* Right Section: View Toggles and Add Button */}
                <div className="headerRightSection">
                  <div className="viewToggles">
                    <div className="sortBoxLayoutIcons">
                      {filesActiveTab !== 2 && (
                        <div
                          className="filesIcon"
                          style={{
                            backgroundColor:
                              layout === "grid"
                                ? "var(--fill-brand-weak)"
                                : "var(--background-bg-dark)"
                          }}
                          onClick={() => setLayout("grid")}
                        >
                          <SortIcons
                            color={
                              theme === "light" &&
                                (layout === "grid" || layout === "table")
                                ? "#67308F"
                                : theme === "dark" &&
                                  (layout === "grid" || layout === "table")
                                  ? "var(--fill-brand-strong)"
                                  : "var(--fill-brand-weak)"
                            }
                            type={layout === "grid" ? "layoutSelect" : "layout"}
                          />
                        </div>
                      )}
                      <div
                        className="tableIcon"
                        style={{
                          backgroundColor:
                            layout === "table"
                              ? "var(--fill-brand-weak)"
                              : "var(--background-bg-dark)"
                        }}
                        onClick={() => setLayout("table")}
                      >
                        <SortIcons
                          color={
                            theme === "light" &&
                              (layout === "grid" || layout === "table")
                              ? "#67308F"
                              : theme === "dark" &&
                                (layout === "grid" || layout === "table")
                                ? "var(--fill-brand-strong)"
                                : "var(--fill-brand-weak)"
                          }
                          type={layout === "table" ? "base" : "baseSelect"}
                        />
                      </div>
                      {false && <div
                        className="sortIcon"
                        style={{
                          backgroundColor: theme === "light" ? "#fff" : "transparent"
                        }}
                        onClick={() => setIsSortRotated(!isSortRotated)}
                      >
                        <span className={`order ${isSortRotated ? "asc" : "desc"}`}>
                          <SortIcons type="order" />
                        </span>
                      </div>}
                    </div>
                  </div>
                  {filesActiveTab !== 2 && (
                    <div className="inviteUsersButton" style={{ position: "relative" }}>
                      <Button
                        title="+ Add"
                        type="violet"
                        width="fit-content"
                        onClick={handleAddFile}
                      />
                      {showAddFileDropdown && window.filesWrapperProps && !isMobile && (
                        <div ref={addFileDropdownRef} className="addFileDropdown" style={{ position: "absolute", top: "100%", right: 0, zIndex: 1000 }}>
                          <TextDropDown
                            content={addNewDropDownOptions}
                            width="200px"
                            {...window.filesWrapperProps}
                            setIsDropDownVisible={setShowAddFileDropdown}
                            setAddFile={setShowAddFileDropdown}
                          />
                        </div>
                      )}
                    </div>
                  )}
                </div>
              </div>
            )}

            {/* Secrets Search Bar and Add Button - Only show when Secrets tab is active */}
            {!isMobile && activeCard === PINS_INDEX && !setting && (
              <div className="HomepageWrapperHeadSearchSort">
                <div className="searchInput">
                  <Input
                    searchIconBool={true}
                    placeholder="Search Ysafe PINS"
                    value={secretsSearchQuery}
                    onChange={handleSecretsSearchQuery}
                    clear={secretsSearchQuery && true}
                    handleClear={clearSecretsSearchQuery}
                    bg={theme === "light" ? "#fff" : "transparent"}
                  />
                </div>
                <div className="inviteUsersButton">
                  <Button
                    title="+ Add"
                    type="violet"
                    width="fit-content"
                    onClick={() => {
                      if (window.secretsManagementProps?.handleCreateSecretModal) {
                        window.secretsManagementProps.handleCreateSecretModal();
                      }
                    }}
                  />
                </div>
              </div>
            )}

            {/* Settings Search Bar and Invite Users Button - Only show when Manage Users is active */}
            {!isMobile && setting && manageUserState === "manageUser" && (
              <div className="HomepageWrapperHeadSearchSort">
                <div className="searchInput">
                  <Input
                    searchIconBool={true}
                    placeholder="Search by name"
                    value={settingsSearchQuery}
                    onChange={handleSettingsSearchQuery}
                    clear={settingsSearchQuery && true}
                    handleClear={clearSettingsSearchQuery}
                    bg={theme === "light" ? "#fff" : "transparent"}
                  />
                </div>
                <div className="inviteUsersButton">
                  <Button
                    title="+ Invite Users"
                    type="violet"
                    width="fit-content"
                    onClick={handleInviteUsers}
                  />
                </div>
              </div>
            )}

            {/* Settings Search Bar and Add Team Button - Only show when Manage Team is active */}
            {!isMobile && setting && manageUserState === "manageTeam" && (
              <div className="HomepageWrapperHeadSearchSort">
                <div className="searchInput">
                  <Input
                    searchIconBool={true}
                    placeholder="Search by team name"
                    value={manageTeamSearchQuery}
                    onChange={handleManageTeamSearchQuery}
                    clear={manageTeamSearchQuery && true}
                    handleClear={clearManageTeamSearchQuery}
                    bg={theme === "light" ? "#fff" : "transparent"}
                  />
                </div>
                <div className="inviteUsersButton">
                  <Button
                    title="+ Add Team"
                    type="violet"
                    width="fit-content"
                    onClick={handleAddTeam}
                  />
                </div>
              </div>
            )}

            {/* Settings Search Bar and Add Role Button - Only show when Manage Role is active */}
            {!isMobile && setting && manageUserState === "manageRole" && (
              <div className="HomepageWrapperHeadSearchSort">
                <div className="searchInput">
                  <Input
                    searchIconBool={true}
                    placeholder="Search by role name"
                    value={manageRoleSearchQuery}
                    onChange={handleManageRoleSearchQuery}
                    clear={manageRoleSearchQuery && true}
                    handleClear={clearManageRoleSearchQuery}
                    bg={theme === "light" ? "#fff" : "transparent"}
                  />
                </div>
                <div className="inviteUsersButton">
                  <Button
                    title="+ Add Role"
                    type="violet"
                    width="fit-content"
                    onClick={handleAddRole}
                  />
                </div>
              </div>
            )}

            {/* Navbar Icons, Bell, and Profile Section */}
            {/* Navbar Icons, Bell, and Profile Section - DESKTOP ONLY */}
            {!isMobile && (
              <div className="HomepageWrapperHeadBell">
                {/* Navbar Icons - Filter, Table/Chart View, Download - Only show in Ysentinel Analysis section WITH DATA */}
                {!setting && activeCard === YSENTINEL_ANALYSIS_INDEX && hasYsentinelData && (
                  <div className="top-navbar" style={{ display: "flex", alignItems: "center", gap: "8px", marginRight: "8px" }}>
                    <div className="top-navbar-right">
                      <div className="view-toggle-buttons" role="tablist" aria-label="View mode">
                        <button
                          type="button"
                          className="filter-toggle-btn"
                          title="Filters"
                          onClick={(e) => {
                            e.stopPropagation();
                            document.dispatchEvent(new CustomEvent("toggleFilters"));
                          }}
                          aria-label="Toggle filters"
                        >
                          <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <path d="M22 4H2l8 9v7l4 2v-9l8-9z" strokeLinecap="round" strokeLinejoin="round" />
                          </svg>
                          <span className="visually-hidden">Toggle filters</span>
                        </button>

                        <button
                          type="button"
                          onClick={() => setViewMode("table")}
                          className={`view-toggle-btn ${viewMode === "table" ? "active" : ""}`}
                          aria-pressed={viewMode === "table"}
                          title="Table View"
                        >
                          <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" strokeWidth="1.5">
                            <rect x="3.5" y="3.5" width="17" height="17" rx="2" />
                            <path d="M3.5 9.5h17" />
                            <path d="M3.5 14.5h17" />
                            <path d="M9.5 3.5v17" />
                          </svg>
                          <span className="visually-hidden">Table view</span>
                        </button>

                        <div className="charts-download-wrapper" style={{ position: "relative" }}>
                          <button
                            type="button"
                            title="Download CSV"
                            className="charts-download-btn"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              document.dispatchEvent(new CustomEvent("downloadCharts", { detail: { format: "csv" } }));
                              showToast("Download successful", "success");
                            }}
                          >
                            <svg viewBox="0 0 24 24" width="18" height="18" aria-hidden="true" focusable="false" fill="none" stroke="currentColor" strokeWidth="1.6">
                              <path d="M12 3v12" strokeLinecap="round" strokeLinejoin="round" />
                              <path d="M8 11l4 4 4-4" strokeLinecap="round" strokeLinejoin="round" />
                              <rect x="4" y="17" width="16" height="3" rx="1" />
                            </svg>
                            <span className="visually-hidden">Download</span>
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                )}

                {/* Operation Panel Toggle Button - Only show when Files section is active */}
                {!isMobile && !setting && activeCard === FILES_INDEX && (
                  <div
                    className="bellIcon operationPanelToggle"
                    onClick={() => {
                      document.dispatchEvent(new CustomEvent("toggleOperationPanel"));
                      setProfile(false);
                      setShowNotifications(false);
                    }}
                    title="Toggle Operation Panel"
                  >
                    <div className="svg">
                      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path d="M12 8V12L15 15M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke={theme === "light" ? "#7D708A" : "#BDB8C2"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                    </div>
                  </div>
                )}

                {/* Profile */}
                <div className="arrow" ref={profileRef}>
                  <span className={theme === "dark" ? "spanDark" : ""} onClick={() => setProfile(true)}>
                    {headerProfilePicUrl ? (
                      <img src={headerProfilePicUrl} alt="Profile" className="header-profile-pic" />
                    ) : (
                      sessionStorage.getItem("mail") === null ? "@" : (sessionStorage.getItem("mail")[0]).toUpperCase()
                    )}
                  </span>
                  {profile && (
                    <Profile setSettings={setSetting} settings={setting} setProfile={setProfile} clearYsentinalHistory={clearYsentinalHistory} onProfilePicLoad={setHeaderProfilePicUrl} canRenewPlan={canRenewPlan} />
                  )}
                </div>
              </div>
            )}

          </div>
          <div className={`HomepageWrapperMain ${isMobile && activeCard === YSENTINEL_ANALYSIS_INDEX && viewMode === "charts" ? "charts-view-layout" : ""} ${!setting && [YSENTINEL_SUMMARY_INDEX, YSENTINEL_FILES_INDEX, YSENTINEL_USERS_INDEX, YSENTINEL_LOCATIONS_INDEX].includes(activeCard) ? "ysd-dashboard-active" : ""} ${!setting && ysentinelSectionTabs.some(t => t.index === activeCard) ? "ysentinel-section-active" : ""}`}>
            {setting ? (
              <SettingsContainer
                searchQuery={settingsSearchQuery}
                setSearchQuery={setSettingsSearchQuery}
                manageTeamSearchQuery={manageTeamSearchQuery}
                setManageTeamSearchQuery={setManageTeamSearchQuery}
                manageRoleSearchQuery={manageRoleSearchQuery}
                setManageRoleSearchQuery={setManageRoleSearchQuery}
                onManageUserChange={handleManageUserChange}
                onProfileUpdated={refreshHeaderProfilePic}
                backendOperations={backendOperations}
              />
            ) : ysentinelSectionTabs.some(t => t.index === activeCard) ? (
              <YsentinelDataProvider
                navigate={(target) => {
                  // Map a logical dashboard name to its activeCard index. Used
                  // by cross-dashboard pivots (e.g. UsersDashboard's
                  // FilesTouchedCard click → Files tab with that file selected).
                  const TARGET_INDEX = {
                    files:     YSENTINEL_FILES_INDEX,
                    users:     YSENTINEL_USERS_INDEX,
                    locations: YSENTINEL_LOCATIONS_INDEX,
                    summary:   YSENTINEL_SUMMARY_INDEX,
                    analysis:  YSENTINEL_ANALYSIS_INDEX,
                  };
                  const idx = TARGET_INDEX[target];
                  if (typeof idx === "number" && idx >= 0) setActiveCard(idx);
                }}
              >
                <div
                  className={`ysentinel-tabs-host${
                    activeCard === YSENTINEL_ANALYSIS_INDEX && isHistoryOpen ? " has-history-open" : ""
                  }${
                    activeCard === YSENTINEL_ANALYSIS_INDEX ? " has-history-toggle" : ""
                  }`}
                >
                  <Tabs
                    tabsTitles={ysentinelSectionTabs.map(t => t.label)}
                    activeTab={ysentinelSectionTabs.findIndex(t => t.index === activeCard)}
                    setActiveTab={(i) => setActiveCard(ysentinelSectionTabs[i].index)}
                    showTabIcons={false}
                    marginBottom="0px"
                  />
                </div>
                {/* Files dashboard scopes itself to a selected file's full
                    lifecycle, so the global range picker doesn't apply there. */}
                {[YSENTINEL_SUMMARY_INDEX, YSENTINEL_FILES_INDEX, YSENTINEL_USERS_INDEX].includes(activeCard) && <TimeRangePicker />}
                {data[validActiveCard] || data[0]}
              </YsentinelDataProvider>
            ) : (
              data[validActiveCard] || data[0]
            )}
            {/* New Doc/Sheet Modal */}
            <NewFileModal
              show={showNewFileModal}
              onClose={() => setShowNewFileModal(false)}
              onCreate={async (fileName, fileType) => {
                const currentFolder = window.filesWrapperProps?.path || [];
                const parentPath = currentFolder.length === 0 ? "/" : `/${currentFolder.join("/")}`;
                const extension = fileType === "doc" ? ".idoc" : ".isheet";
                const fullFolderName = parentPath.endsWith("/") ? parentPath : parentPath + "/";
                const fullPath = fullFolderName + fileName + extension;

                try {
                  await Item.getItem(fullPath, false);
                  showToast("File already exists with this name", "error");
                  return;
                } catch (e) {
                  // File does not exist, proceed
                }

                setShowNewFileModal(false);

                // Dispatch event for TableTest to handle (instead of showing local viewers)
                window.dispatchEvent(new CustomEvent('createNewFile', {
                  detail: {
                    type: fileType,  // "doc" or "sheet"
                    fileName: fileName + extension,
                    parentPath: parentPath
                  }
                }));
              }}
              fileType={newFileType}
            />
            <AdvancedSearchModal
              isOpen={advancedSearchOpen}
              onClose={() => setAdvancedSearchOpen(false)}
              currentPath={window.filesWrapperProps?.path || []}
            />
          </div>
        </div>
      </div>
      {isPlanExpired && <PlanExpiredMarquee />}
    </section >
  );
}

export default Homepage;